import { FilterOptions } from '../../../domain/filter/filter-options';

export const FilterSelection = {
    template: require('./filter-selection.html'),
    controller: class FilterSelection {
        private filterOptions: FilterOptions;
        private onClearFilter: Function;

        clearFilter(): void {
            this.filterOptions.clear();
            this.onClearFilter();
        }
    },
    bindings: {
        filterOptions: '<',
        onClearFilter: '&'
    },
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/commons/components/filter-selection/filter-selection.ts